import React, { useState } from 'react';
import './NavBar.css';
import hamburgerButton from '../images/buttons/hamburger.svg';
import cancelButton from '../images/buttons/cancel.svg';
import styled from 'styled-components';
import { useMediaQuery } from 'react-responsive';


const DBHeader = styled("div")`
  z-index: 10;
  background: black;
  width: 100%;
  color: white;
  font-family: 'ITC Century';
  font-style: normal;
  font-weight: 400;
  text-align: center;
  text-transform: uppercase;
  font-size: 18px;
  line-height: 21.6px;
  height: 29.2px;
`;



export default function NavBar() {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    
    const isMobile = useMediaQuery({ query: '(max-width: 456px)' });

    const navItems = ['Title', 'Letter', 'Interactive', 'News', 'Sports', 'Arts', 'Opinion', 'Quad', 'Multimedia', 'Prime', '-30-', 'About'];
    // const navLinks = ['/', '/editor-letter', '/interactive', '/news', '/sports', '/arts', '/opinion', '/the-quad', '/multimedia', '/prime', '/-30-', '/about'];
    const navLinks = ['#title', '#editor-letter', '#interactive', '#news', '#sports', '#arts', '#opinion', '#quad', '#multimedia', '#prime', '#thirty', '#about'];


// const [sticky, setSticky] = useState(null);

// useEffect(() => {
//   const navbar = document.getElementById("navbar");
//   setSticky(navbar.offsetTop);

//   const myFunction = () => {
//     if (window.scrollY >= sticky) {
//       navbar.classList.add("sticky")
//     } else {
//       navbar.classList.remove("sticky");
//     }
//   }

//   window.onscroll = myFunction;

//   // Clean up the event listener when the component unmounts
//   return () => {
//     window.onscroll = null;
//   };
// }, [sticky]);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
        console.log("got clicked");
    };
    
    return (
        <nav className="navbar" id="navbar">
            {isMobile ? <DBHeader>Daily Bruin</DBHeader> : null}
            <div className={`nav ${isMobileMenuOpen ? 'nav-mobile-open' : ''}`}>
                {navItems.map((item, index) => (
                    <div key={item} className='nav-component'>
                        <button className='nav-button'>
                            <a href={navLinks[index]} className='nav-link' onClick={toggleMobileMenu}>{item}</a>
                        </button>
                    </div>
                ))}
            </div>
            <button className="hamburger" onClick={toggleMobileMenu}>
                <img src={hamburgerButton} alt="Open Menu" />
            </button>
            {isMobileMenuOpen && (
                <div className="mobile-menu">
                    <button className="close" onClick={toggleMobileMenu}>
                        <img src={cancelButton} alt="Close Menu" />
                    </button>
                </div>
            )}
        </nav>
    );
}